<template>
    <div>
        <!-- 第一行：积分信息 + 规则卡片 -->
        <div class="points-header">
            <div class="points-info">
                <div class="points-title">
                    <img src="/static/shop/star.png" alt="" style="width: 20px; height: 20px; margin-right: 6px;" />
                    <div class="points-label">我的积分</div>
                </div>
                <div class="points-details">
                    <div class="points-number">{{ totalPoints }}</div>
                    <div class="earn-points" @click="goEarnPoints">
                        赚积分<span class="arrow">&gt;</span>
                    </div>
                </div>
            </div>
            <div class="rule-card" @click="showRule">
                <img src="/static/shop/image.png" alt="" style="width: 124px; height: 100px;margin-left: 40px;" />
                <div class="rule-placeholder">规则说明</div>
            </div>
        </div>
        <div class="points-mall-container">
            <!-- 第二行：筛选标签（改为与猜你喜欢选项卡相同的样式） -->
            <div class="filter-tabs">
                <div v-for="tab in filterTabs" :key="tab.value" class="tab-item" @click="activeFilter = tab.value">
                    <div class="tab" :class="{ active: activeFilter === tab.value }">{{ tab.label }}</div>
                    <div v-if="activeFilter === tab.value" class="tab-bar"></div>
                </div>
            </div>

            <!-- 第三行：商品列表（两列网格） -->
            <div class="goods-grid">
                <div v-for="item in filteredProducts" :key="item.id" class="product-card" @click="goToDetail(item.id)">
                    <img :src="item.image" class="product-img" alt="" />
                    <div class="product-info">
                        <div class="product-title">{{ item.title }}</div>
                        <!-- 积分价格 -->
                        <div class="points-price">{{ item.pointsPrice }}积分</div>
                        <!-- 市场价 + 去兑换按钮 同一行 -->
                        <div class="market-row">
                            <span class="market-price">市场价：{{ item.marketPrice }}</span>
                            <div class="exchange-btn" @click.stop="exchange(item)">
                                去兑换
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 无商品提示 -->
            <div v-if="filteredProducts.length === 0" class="empty-tip">
                暂无相关商品
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PointsMall',
    data() {
        return {
            // 积分总数（示例数据）
            totalPoints: 54289,
            // 筛选标签
            filterTabs: [
                { label: '全部', value: 'all' },
                { label: '0-500', value: '0-500' },
                { label: '500-1000', value: '500-1000' },
                { label: '1000以上', value: '1000+' }
            ],
            activeFilter: 'all',
            // 商品列表数据（积分商品）
            products: [
                {
                    id: 1,
                    title: '荣事达电饭煲',
                    pointsPrice: 6800,
                    marketPrice: 699,
                    image: '/static/home/Rectangle 1384.png'
                },
                {
                    id: 2,
                    title: '荣事达电饭煲',
                    pointsPrice: 6800,
                    marketPrice: 699,
                    image: '/static/home/Rectangle 1384.png'
                },
                {
                    id: 3,
                    title: '智能空气炸锅',
                    pointsPrice: 450,
                    marketPrice: 299,
                    image: '/static/home/Rectangle 1384.png'
                },
                {
                    id: 4,
                    title: '山茶花洗护套装',
                    pointsPrice: 800,
                    marketPrice: 129,
                    image: '/static/home/Rectangle 1384.png'
                },
                {
                    id: 5,
                    title: '有机五常大米',
                    pointsPrice: 1200,
                    marketPrice: 89.9,
                    image: '/static/home/Rectangle 1384.png'
                },
                {
                    id: 6,
                    title: '精品牛肉礼盒',
                    pointsPrice: 1500,
                    marketPrice: 259,
                    image: '/static/home/Rectangle 1384.png'
                },
                {
                    id: 7,
                    title: '便携榨汁杯',
                    pointsPrice: 50,
                    marketPrice: 99,
                    image: '/static/home/Rectangle 1384.png'
                },
                {
                    id: 8,
                    title: '多功能料理锅',
                    pointsPrice: 3000,
                    marketPrice: 499,
                    image: '/static/home/Rectangle 1384.png'
                }
            ]
        };
    },
    computed: {
        filteredProducts() {
            if (this.activeFilter === 'all') {
                return this.products;
            }
            if (this.activeFilter === '0-500') {
                return this.products.filter(p => p.pointsPrice <= 500);
            }
            if (this.activeFilter === '500-1000') {
                return this.products.filter(p => p.pointsPrice > 500 && p.pointsPrice <= 1000);
            }
            if (this.activeFilter === '1000+') {
                return this.products.filter(p => p.pointsPrice > 1000);
            }
            return this.products;
        }
    },
    methods: {
        goEarnPoints() {
            console.log('赚积分点击');
            // 可跳转积分任务页
        },
        showRule() {
            console.log('显示积分规则');
            // 可弹出规则弹窗
        },
        goToDetail(id) {
            console.log(`查看商品详情: ${id}`);
        },
        exchange(item) {
            console.log(`兑换商品: ${item.title}`);
            // 可调用兑换接口
        }
    }
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.points-mall-container {
    max-width: 450px;
    margin: 0 auto;
    background: #FBFFF9;
    padding: 16px 16px 100px 16px;
    font-family: Inter, Inter;
    min-height: 100vh;
    border-radius: 12px 12px 0px 0px;
}

/* 第一行：积分信息 + 规则卡片 */
.points-header {
    display: flex;
    gap: 12px;
    background: url('/static/shop/bgi.png');
}

.points-info {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    border-radius: 20px;
    padding: 16px 16px 18px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

.points-title {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.points-details {
    display: flex;
    align-items: end;
}

.points-label {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
}

.points-number {
    font-size: 36px;
    font-weight: 500;
    color: #000000;
    line-height: 1;
    margin-right: 8px;

}

.earn-points {
    font-size: 12px;
    background: #06CF33;
    color: #FFFFFF;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    padding: 0 8px;
    margin-bottom: 2px;
}

.arrow {
    margin-left: 4px;
    font-size: 14px;
}

.rule-card {
    flex: 1;
    border-radius: 20px;
    padding: 16px 0 0 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
    display: flex;
    align-items: center;
}

.rule-placeholder {
    margin-left: auto;
    text-align: center;
    font-size: 10px;
    color: #004D0F;
    writing-mode: vertical-lr;
    margin-bottom: 6px;
    padding: 6px 0;
    width: 18px;
    background: linear-gradient(95deg, rgba(6, 207, 51, 0.36) 0%, rgba(6, 207, 51, 0.65) 100%);
    border-radius: 9px 0px 0px 9px;
}

/* 第二行：筛选标签（与猜你喜欢选项卡样式一致） */
.filter-tabs {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 20px;
    margin: 0 0 20px 0;
    padding-bottom: 6px;
}

.tab-item {
    position: relative;
    cursor: pointer;
}

.tab {
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 14px;
    color: #000;
    transition: all 0.2s;
}

.tab.active {
    font-weight: 500;
    font-size: 14px;
    color: #000;
}

.tab-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 6px;
    background: #06CF33;
    border-radius: 3px;
    opacity: 0.5;
}

/* 商品网格 */
.goods-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

/* 商品卡片样式（去除描述和标签，调整布局） */
.product-card {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
    transition: transform 0.2s;
    cursor: pointer;
}

.product-card:active {
    transform: scale(0.98);
}

.product-img {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    background-color: #f0f0f0;
    display: block;
}

.product-info {
    padding: 10px 8px 12px;
}

.product-title {
    font-weight: 600;
    font-size: 14px;
    color: #222;
    line-height: 1.4;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: left;
}

.points-price {
    font-size: 18px;
    font-weight: 800;
    color: #ff3b2f;
    margin-bottom: 8px;
    text-align: left;
}

.market-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.market-price {
    font-size: 11px;
    color: #b0b0b6;
}

.exchange-btn {
    border-radius: 20px;
    padding: 0 6px;
    font-size: 11px;
    font-weight: 500;
    color: #06CF33;
    transition: background 0.2s;
    white-space: nowrap;
    border: 1px solid #06CF33;
    border-radius: 7px 7px 7px 7px;
}

.exchange-btn:active {
    background: #05b52d;
}

.empty-tip {
    text-align: center;
    font-size: 14px;
    color: #999;
    padding: 40px 0;
}

/* 小屏适配 */
@media (max-width: 400px) {
    .points-mall-container {
        padding: 12px 12px 100px 12px;
    }

    .points-number {
        font-size: 28px;
    }

    .points-price {
        font-size: 16px;
    }

    .filter-tabs {
        gap: 16px;
    }

    .tab {
        font-size: 14px;
    }

    .tab.active {
        font-size: 16px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/PointsMall.vue